import { useBreadcrumb } from '~/composables/useBreadcrumb'

export default defineNuxtRouteMiddleware(async (to, _from) => {
  // Set breadcrumbs
  const { setBreadcrumbs } = useBreadcrumb()
  setBreadcrumbs(to)
})
